import { Card } from '@blueprintjs/core';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
    height: 100%;
`;
